import React, { forwardRef } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import Panel from "Portal/NewPortal/Shared/Panel";
import {
  Div
  //Text2
} from "components/Base";
import {
  getSectionHeaderColor,
  getSectionHeaderFont,
  getSectionHeaderSize,
  getSectionIconById,
  getWikiPages
} from "Portal/NewPortal/PortalHome/selectors";
import { noop } from "utils/General";
import { actions } from "Portal/NewPortal/PortalHome/model";
import Tabs from "ui-kit/Tabs/View";
import { RESOURCES_CARD_TABS_INSTANCE_ID } from "../../../../Wrapper/constants";
import WikiPageThumbnail from "./WikiPageThumbnail";
import QuickLinkThumbnail from "./QuickLinkThumbnail";
import { getters as TabGetters } from "ui-kit/Tabs";
import { actions as ResourcesFlyOverActions } from "Portal/NewPortal/Sections/Resources/FlyOver/model";

const decorate = R.compose(
  connect(
    state => ({
      sectionHeaderColor: getSectionHeaderColor(state),
      sectionHeaderFont: getSectionHeaderFont(state),
      sectionHeaderSize: getSectionHeaderSize(state),
      activeTab: TabGetters.selectedTab(state, {
        instanceId: RESOURCES_CARD_TABS_INSTANCE_ID
      }),
      wikiPages: getWikiPages(state)
    }),
    {
      goToSection: actions.setSelectedCategory,
      openResourcesFlyOver: ResourcesFlyOverActions.openResourcesFlyOver,
      setActiveWikiPage: actions.setActiveWikiPage
    }
  )
);

const PARENT_CONTAINER_STYLES = {
  maxHeight: "400px",
  height: "auto",
  overflow: "auto"
};

const GAPPED_CONTAINER_STYLES = { gap: "16px" };

const Resources = forwardRef(
  (
    {
      wikiPages = [],
      quickLinks = [],
      activeTab = "wiki",
      // wikiPages = MOCK_WIKI_PAGES,
      // quickLinks = MOCK_QUICK_LINKS,
      // goToSection = noop,
      // openResourcesFlyOver = noop,
      setActiveWikiPage = noop
    },
    ref
  ) => {
    const icon = getSectionIconById("resources") || null;
    return (
      <Panel
        title="Resources"
        panelContainerStyle={PARENT_CONTAINER_STYLES}
        icon={icon}
        // onClickHeader={() => goToSection({ category: SECTIONS_IDS.RESOURCES })}
      >
        <div ref={ref}>
          <Div
            display="column.flex-start.flex-start"
            style={GAPPED_CONTAINER_STYLES}
          >
            <Div
              width={1}
              bb={1}
              bc="#E7E6EA"
              display="row.flex-start.flex-start"
            >
              <Tabs
                instanceId={RESOURCES_CARD_TABS_INSTANCE_ID}
                tabs={[
                  {
                    title: `Wiki Pages (${wikiPages.length})`,
                    id: "wiki"
                  }
                  // {
                  //   title: `Quick Links (${quickLinks.length})`,
                  //   id: "quick"
                  // }
                ]}
                iniSelected={activeTab}
                tabStyle={{
                  className: "accentable-tab",
                  fs: 4,
                  pb: 3,
                  flex: 1
                }}
              />
            </Div>
            <Div width={1}>
              {activeTab === "wiki" ? (
                <Div
                  display="column.flex-start.flex-start"
                  style={GAPPED_CONTAINER_STYLES}
                  width={1}
                >
                  {R.length(wikiPages) > 0
                    ? wikiPages
                        // .slice(0, 3)
                        .map(({ id, image, title, text }, index) => (
                          <WikiPageThumbnail
                            setActiveWikiPage={setActiveWikiPage}
                            key={`wiki-thumbnail-${index}`}
                            image={image}
                            text={text}
                            title={title}
                            id={id}
                          />
                        ))
                    : "No wiki pages found"}
                </Div>
              ) : (
                <Div
                  display="column.space-between.center"
                  style={GAPPED_CONTAINER_STYLES}
                  width={1}
                >
                  {R.length(quickLinks) > 0
                    ? quickLinks
                        .slice(0, 4)
                        .map(({ url, color, icon, text }, index) => (
                          <QuickLinkThumbnail
                            key={`quick-thumbnail-${index}`}
                            url={url}
                            color={color}
                            icon={icon}
                            text={text}
                          />
                        ))
                    : "No quick links found"}
                </Div>
              )}
            </Div>

            {/*
            {(activeTab === "wiki" && wikiPages.length > 3) ||
            (activeTab === "quick" && quickLinks.length > 4) ? (
              <Div width={1}>
                <Text2 bold color="#4263EB" onClick={openResourcesFlyOver}>
                  View more
                </Text2>
              </Div>
            ) : null}
            */}
          </Div>
        </div>
      </Panel>
    );
  }
);

export default decorate(Resources);
